module.exports = __webpack_public_path__ + "img/47.8833fc3c.png";